export const ascendingPrice = (a, b) => a.price - b.price;
export const descendingPrice = (a, b) => b.price - a.price;
